import FasterEvent from '../fasterEvent'

/**
 * Fired when a VIU `?hash=` decrypts but carries no MSISDN, so there is no subscriber to sign in.
 * Raised for any status — the partner's sample for this case reports 121 (HE failure), not 101. We
 * use the payload's `productcode` to re-run header enrichment against that product's region instead
 * of dead-ending on the partner error page (`retryViuHeForMissingMsisdn`).
 *
 * `redirected` separates "retry fired" from "fell through to the error page"; `reason` says why a
 * retry did not happen (`noProductCode` — partner omitted the field, `unknownProductCode` — not in
 * `VUE_APP_VIU_REGIONS_JSON`, `alreadyRetried` — guard tripped, typically HE failing off-carrier,
 * `disabled` — kill switch). `countryCode` / `carrier` come from the resolved region row and are
 * empty when the product code never resolved.
 */
export default new FasterEvent(
  { id: 'viu_missing_msisdn_retry', revision: 0 },
  (eventBuilder, parameters) => {
    return eventBuilder
      .dimension('productCode', parameters.productCode || '')
      .dimension('countryCode', parameters.countryCode || '')
      .dimension('carrier', parameters.carrier || '')
      .dimension('reason', parameters.reason || '')
      .dimension('redirected', String(Boolean(parameters.redirected)))
      .build()
  }
)
